/**
 * @generated SignedSource<<a2e73a3f6555acc57594db1fc7cf2add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableSalesforceInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DisableSalesforceMutation$variables = {
  input: DisableSalesforceInput;
};
export type DisableSalesforceMutation$data = {
  readonly disableSalesforce: {
    readonly company: {
      readonly salesforceEnabled: boolean | null;
      readonly newSalesforceEnabled: boolean | null;
    } | null;
  } | null;
};
export type DisableSalesforceMutation = {
  variables: DisableSalesforceMutation$variables;
  response: DisableSalesforceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newSalesforceEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableSalesforceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableSalesforcePayload",
        "kind": "LinkedField",
        "name": "disableSalesforce",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableSalesforceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableSalesforcePayload",
        "kind": "LinkedField",
        "name": "disableSalesforce",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2abe5e51cab881c4191cb934042511ee",
    "id": null,
    "metadata": {},
    "name": "DisableSalesforceMutation",
    "operationKind": "mutation",
    "text": "mutation DisableSalesforceMutation(\n  $input: DisableSalesforceInput!\n) {\n  disableSalesforce(input: $input) {\n    company {\n      salesforceEnabled\n      newSalesforceEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c69821e6473c071485461da16fce2ce";

export default node;
